import React from 'react'
import { APIClient } from '@/services'
import { Select } from '@/components'
import { QuestionProps } from '../types'

export const JobRoleCard = (props: QuestionProps) => {
  const { form, disabled } = props

  const { data: options } = APIClient.Session.useProfileOptions()

  return (
    <Select
      {...form.register('department')}
      options={options?.department}
      arrowIconName='chevron-right'
      placeholder='Select one'
      label='Job role'
      variants={['noError', 'prompt']}
      disabled={disabled}
    />
  )
}
